import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { API_CONFIG, ApiCallingV2Service, ApiResponseModel, ResponseUtilityService } from '@zayan-erp/shared';

export interface SellingPriceHistory {
  id: string;
  modelElevationProductId: string;
  effectiveDate: Date;
  quantity: number;
  unitPrice: number;
  amount: number;
  retailCredit: number;
}
@Injectable({
  providedIn: 'root'
})
export class SellingPriceHistoryService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readSellingPriceHistory(id: string): Observable<SellingPriceHistory[]> {
    return this.#http.getData(`${this.baseUrl}/modelelevationproducts/${id}/prices`, {
      showLoader: true,
      showMessage: true
    });
  }
  createSellingPriceHistory(sellingPriceHistory: SellingPriceHistory): Observable<SellingPriceHistory> {
    return this.#http.postData(
      `${this.baseUrl}/modelelevationproducts/${sellingPriceHistory.modelElevationProductId}/prices`,
      { showLoader: true, showMessage: true, message: 'Selling Price History created successfully' },
      sellingPriceHistory
    );
  }
  updateSellingPriceHistory(sellingPriceHistory: SellingPriceHistory): Observable<SellingPriceHistory> {
    return this.#http.putData(
      `${this.baseUrl}/sellingpricehistory/${sellingPriceHistory.modelElevationProductId}/prices/${sellingPriceHistory.id}`,
      sellingPriceHistory,
      { showLoader: true, showMessage: true }
    );
  }
}
